document.addEventListener('DOMContentLoaded', function() {
  const timelineContainers = document.querySelectorAll('.custom-timeline');
  
  if (timelineContainers.length === 0) return;

  timelineContainers.forEach(container => {
    initTimelineActiveStates(container);
  });

  function initTimelineActiveStates(container) {
    const timelineItems = container.querySelectorAll('.timeline__item');
    const stepButtons = container.querySelectorAll('.timeline__item--step');
    
    if (timelineItems.length === 0 || stepButtons.length === 0) return;

    // Handle scroll events for responsive updates
    let scrollTimeout;
    function handleScroll() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        updateActiveStatesByPosition(timelineItems, stepButtons);
      }, 16); // ~60fps for smoother updates
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);

    // Initial check
    updateActiveStatesByPosition(timelineItems, stepButtons);
  }

  function updateActiveStatesByPosition(timelineItems, stepButtons) {
    const windowHeight = window.innerHeight;
    const viewportCenter = windowHeight / 2;
    
    let bestIndex = 0;
    let bestScore = -Infinity;

    timelineItems.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      
      // Calculate how much of the item is visible
      const visibleTop = Math.max(0, rect.top);
      const visibleBottom = Math.min(windowHeight, rect.bottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);
      const totalHeight = rect.height;
      const visibilityRatio = visibleHeight / totalHeight;
      
      // Only consider items that are at least partially visible
      if (visibilityRatio > 0) {
        // Calculate distance from viewport center (closer = better)
        const itemCenter = rect.top + (rect.height / 2);
        const distanceFromCenter = Math.abs(itemCenter - viewportCenter);
        const maxDistance = windowHeight; // Normalize distance
        const centerScore = 1 - (distanceFromCenter / maxDistance);
        
        // Combine visibility ratio and center proximity
        // Weight visibility more heavily, but consider center proximity
        const score = (visibilityRatio * 0.7) + (centerScore * 0.3);
        
        // Add a small bonus for being higher up when scores are very close
        const positionBonus = (timelineItems.length - index) * 0.001;
        const finalScore = score + positionBonus;
        
        // Special case: if item is more than 50% visible and closest to top
        if (visibilityRatio > 0.5 && rect.top >= 0 && rect.top < 100) {
          finalScore += 0.2; // Bonus for being near top and well visible
        }
        
        if (finalScore > bestScore) {
          bestScore = finalScore;
          bestIndex = index;
        }
      }
    });

    updateActiveStates(stepButtons, bestIndex);
  }

  function updateActiveStates(stepButtons, activeIndex) {
    stepButtons.forEach((button, index) => {
      if (index === activeIndex) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }
});
